// extracted by mini-css-extract-plugin
export var dropdownContainer = "_p6-0";
export var leftAlign = "_p6-4";
export var listItem = "_p6-2";
export var listItemWrapper = "_p6-1";
export var operationText = "_p6-3";